import clsx from 'clsx';

const variants = {
  none: 'rounded-none',
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  round: 'rounded-full',
};

interface IGenericSkeleton {
  variant?: keyof typeof variants;
  width: string;
  height: string;
  margin?: string;
}

export const GenericSkeleton = ({ width, height, margin, variant = 'md' }: IGenericSkeleton) => (
  <div className={clsx(width, height, margin, 'animate-pulse bg-gray-300', variants[variant])} />
);

GenericSkeleton.displayName = 'GenericSkeleton';
